// extracted by mini-css-extract-plugin
export default {"root":"PrivacyPolicy_root__Vr+vU","listStyle":"PrivacyPolicy_listStyle__CAayi","lastUpdated":"PrivacyPolicy_lastUpdated__HURRV marketplaceBodyFontStyles"};